import { type RouteRecordRaw } from 'vue-router'

import { ORDER_PREFIX } from '../public/useOrderRouter'

export const ordersRouter: RouteRecordRaw[] = [
  {
    component: async () => import('../views/OrdersMainView.vue'),
    meta: {
      authZ: ({ user }) => user.can('read', 'order'),
      title: 'restaurant.orders',
    },
    name: ORDER_PREFIX,
    path: 'orders',
  },
  {
    component: async () => import('../views/OrdersDetailView.vue'),
    meta: {
      authZ: ({ user }) => user.can('read', 'order'),
    },
    name: `${ORDER_PREFIX}.detail`,
    path: 'orders/:orderId',
    props: true,
  },
]
